import Vue from "vue";
import isArray from "lodash/isArray";

export default {
	state: {
		_byID: {},
		isFetching: false,
		errorMessage: null,
		lastFetched: null // Timestamp
	},
	getters: {
		list: (state): any[] =>
			(state.byID ? Object.values(state.byID) : []) as any[],
		error: (state): string => state.errorMessage,
		fetching: (state): boolean => state.isFetching
	},
	actions: {},
	mutations: {
		LOAD_LIST_SUCCESS(state: any, items: any[]) {
			// only want to continue if we have something to use.
			if (isArray(items)) {
				const byID = items.reduce((acc, val) => {
					acc[val.id] = val;
					return acc;
				}, {});
				Vue.set(state, "byID", byID);
			}
			state.lastFetched = Date.now();
			state.isFetching = false;
		},
		ITEM_INSERT(state, item) {
			Vue.set(state.byID, item.id.toString(), item);
		},
		ITEM_UPDATE(state, item) {
			Vue.set(state.byID, item.id.toString(), item);
		},
		ITEM_DELETE(state, item) {
			const { id } = item;
			Vue.delete(state.byID, id);
		},
		LOAD_FINISH(state: any) {
			state.lastFetched = Date.now();
			state.isFetching = false;
		},
		LOAD_START(state: any) {
			state.errorMessage = null;
			state.isFetching = true;
		}
	}
};
